import { Box, IconButton, styled } from '@mui/material';

import { colors } from '../../../../theme';

export const S = {
    modal: {
        marginTop: '40px'
    },
    title: {
        color: colors.white90,
        fontFamily: 'Inter',
        fontWeight: 600,
        fontSize: '16px',
        paddingBottom: '10px'

    },
    created: {
        color: colors.lightDimYellowRgba,
        fontFamily: 'Inter',
        fontSize: '12px',
        textDecoration: 'underline',
        paddingLeft: '5px',
        lineHeight: '12px'
    },
    createdTitle: {
        color: colors.white30,
        fontFamily: 'Inter',
        fontSize: '12px'
    },
    rating: {
        color: colors.lightningYellow,
        fontFamily: 'Inter',
        fontWeight: 600,
        fontSize: '12px',
        paddingLeft: '20px',
        lineHeight: '18px'
    },
    text: {
        color: colors.white70,
        fontFamily: 'Inter',
        fontSize: '12px',
        lineHeight: '24px',
        whiteSpace: 'pre-wrap'
    },
    note: {
        color: colors.white50,
        fontFamily: 'Inter',
        fontSize: '11px',
        fontStyle: 'italic',
        lineHeight: '16px'
    }
};

export const CloseButton = styled(IconButton)`
    color: white;
    padding: 0;
`;

export const DescriptionHeader = styled(Box)`
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 8px;
`;

export const DescriptionContent = styled(Box)<{ expanded?: boolean }>`
    overflow: hidden;
    white-space: pre-wrap;
    word-wrap: break-word;
    max-height: ${props => props.expanded ? 'none' : '4.5em'};
    line-height: 1.5em;
`;

export const BlameIssuesTitle = styled(Box)`
    margin-bottom: 8px;
    display: block;
`;

export const HorizontalLine = styled(Box)`
    border: 1px solid ${colors.tuna};
    margin-top: 36px;
    margin-bottom: 36px;
`;

export const CreatedAt = styled(Box)`
    margin-bottom: 10px;
`;

export const RatingBox = styled(Box)`
    display: flex;
    align-items: center;
    margin-bottom: 10px;
`;

export const ReadMoreButton = styled(Box)`
    color: ${colors.lightningYellow};
    font-family: 'Inter';
    font-size: 12px;
    cursor: pointer;
    display: inline;
    margin-left: 4px;
    &:hover {
        text-decoration: underline;
    }
`;

export const TextWrapper = styled(Box)`
    display: block;
    margin-bottom: 16px;
`;
